// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__E61QA","rootSmall":"AddTileButton_rootSmall__1qOrq"};